import { ManualBalanceAccount, MixedCompositeId } from 'interfaces/linkage'
import { State } from 'interfaces/state'
import { createSelector } from 'reselect'
import { manualBalanceAccountsSelector, providerBalanceAccountsSelector } from 'selectors/linkageSelectors'


const providerBalancesMapSelector = createSelector(
  providerBalanceAccountsSelector,
  (providerBalanceAccounts) => {
    if (!providerBalanceAccounts) {
      return {}
    }

    return providerBalanceAccounts.allKeys.reduce<Record<MixedCompositeId, MixedCompositeId[]>>((acc, pbaCid) => {
      const balanceAccount = providerBalanceAccounts.byKey[pbaCid]
      let cids = acc[balanceAccount.providerCid]
      if (!cids) {
        cids = acc[balanceAccount.providerCid] = []
      }

      cids.push(pbaCid)
      return acc
    }, {})
  }
)

export const createActiveAccountBalanceCidsOfProviderSelector = () => createSelector(
  providerBalancesMapSelector,
  (_: State, props: { cid: MixedCompositeId }) => props.cid,
  (providerBalancesMap, pCid) => providerBalancesMap[pCid] || []
)

export const createProviderAccountBalanceSelector = () => createSelector(
  providerBalanceAccountsSelector,
  (_: State, props: { pbaCid: MixedCompositeId }) => props.pbaCid,
  (providerBalanceAccounts, pbaCid) => {
    return providerBalanceAccounts?.byKey[pbaCid] ?? null
  }
)


export const activeManualAccountsSelector = createSelector(
  manualBalanceAccountsSelector,
  (manualBalanceAccounts) => {
    if (!manualBalanceAccounts) {
      return null
    }

    return manualBalanceAccounts.allKeys.reduce<ManualBalanceAccount[]>((acc, cid) => {
      const account = manualBalanceAccounts.byKey[cid]
      acc.push(account)
      return acc
    }, [])
  }
)


